import cx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import ContainerEdit from '@plone/volto/components/manage/Blocks/Container/Edit';
import { setUIState } from '@plone/volto/actions/form/form';
import { Section } from '../../Section/Section';
import type { SectionBlockData } from './SectionView';

type SectionEditProps = {
  data: SectionBlockData;
  block: string;
  selected: boolean;
  [key: string]: unknown;
};

/**
 * Edit do bloco Section: espelho do Grid/Edit.jsx do core, com
 * direction="vertical" e o mesmo wrapper de cor da view (WYSIWYG).
 * O onClick "in-between" reativa a sidebar do container depois de
 * selecionar um bloco interno (hack herdado do Grid/Edit do core).
 */
const SectionBlockEdit = (props: SectionEditProps) => {
  const { data } = props;

  const selectedBlock = useSelector(
    (state: { form: { ui: { sectionSelected?: string | null } } }) =>
      state.form.ui.sectionSelected,
  );
  const dispatch = useDispatch();

  return (
    <div
      className="section-edit"
      onClick={(e: React.MouseEvent & { block?: string }) => {
        if (!e.block) dispatch(setUIState({ sectionSelected: null }));
      }}
      role="presentation"
    >
      <Section
        className={cx('block-section', {
          'odc-section--flush-bottom': data.flushBottom,
          'odc-section--has-heading': !!data.heading,
        })}
        color={data.color ?? 'brand'}
        width={data.width ?? 'default'}
      >
        {data.heading && <h2 className="section__heading">{data.heading}</h2>}
        <ContainerEdit
          {...props}
          selectedBlock={selectedBlock}
          setSelectedBlock={(id: string | null) =>
            dispatch(setUIState({ sectionSelected: id }))
          }
          direction="vertical"
        />
      </Section>
    </div>
  );
};

export default SectionBlockEdit;
